<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'登録・ログインする'">
          <list-item :spanText="'Q. '" :text="'SMS認証コードが届かない'" :urlName="'Help30'"></list-item>
          <list-item :spanText="'Q. '" :text="'WeRUNアプリが使えない機種はありますか？'" :urlName="'Help1'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory51.vue